import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { organiztionService } from "../../services/organiztionService";
import { BULK_REGISTRATION_STATUS } from "../../data/BulkRegistrationConstants";
import { bulkRegistrationService } from "../../services/bulkRegistrationService";

// initial state
const initialState = {
    loading: false,
    error: null,
    data: {
        current_page: 1,
        page_limit: 10,
        total_pages: 1,
        tableData: [], // Add tableData to the initial state
    },
    bulkRegistrationStatus: BULK_REGISTRATION_STATUS.QR_CODE,
};

export const fetchOrganizationList = createAsyncThunk("organizations/fetchOrganizationList", async ({ page, limit }, thunkAPI) => {
    try {
        const response = await organiztionService.getOrganizationsList({
            page,
            limit,
        });
        return response?.data?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
});

export const getBulkExcelSheetList = createAsyncThunk("organizations/getBulkExcelSheetList", async ({ page, limit }, thunkAPI) => {
    try {
        const response = await organiztionService.getExcelSheetData({
            page,
            limit,
        });
        return response?.data?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const getBulkCpd = createAsyncThunk("organizations/getBulkCpd", async ({ page, limit }, thunkAPI) => {
    try {
        const response = await bulkRegistrationService.getBulkCpd({
            page,
            limit,
        });
        return response?.data?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
});

export const fetchOrganizationById = createAsyncThunk("organizations/fetchOrganizationById", async ({ id }, thunkAPI) => {
    try {
        const response = await organiztionService.getOrganisationById({
            id,
        });
        return response?.data?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
});

const organizationSlice = createSlice({
    name: "organizations",
    initialState,
    reducers: {
        handleLoading: (state, action) => {
            state.loading = action.payload;
        },
        handleCurrentPage: (state, action) => {
            state.data.current_page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrganizationList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrganizationList.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.data.tableData = action.payload.data; // Set tableData from response
                if (action.payload.total_pages === 0) {
                    state.data.total_pages = 1;
                } else {
                    state.data.total_pages = action.payload.total_pages;
                }
            })
            .addCase(fetchOrganizationList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getBulkCpd.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBulkCpd.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.data.tableData = action.payload.data; // Set tableData from response
                if (action.payload.total_pages === 0) {
                    state.data.total_pages = 1;
                } else {
                    state.data.total_pages = action.payload.total_pages;
                }
            })
            .addCase(getBulkCpd.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchOrganizationById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrganizationById.fulfilled, (state, action) => {
                state.loading = false;
                state.dashboardData = action.payload;
            })
            .addCase(fetchOrganizationById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});
export const { handleLoading, handleCurrentPage } = organizationSlice.actions;
export default organizationSlice.reducer;
